import { useTabVisibility } from '../../hooks/useTabVisibility.js';
import { useMediaOnTabTitle } from '../../lib/mediaReminder.js';

/**
 * HUD — comportements globaux du jeu, sans rendu.
 * Le nom de zone, la bulle et le nombre de personnes sont affichés par
 * GameHUD (pastille de zone en haut à gauche, bouton Personnes de la barre).
 * L'absence automatique (onglet masqué 30 s) passe le statut à « Absent »,
 * visible sur la pastille du joueur. Onglet caché avec le micro ou la caméra
 * allumé : rappel dans le titre de l'onglet (et notification, lib/mediaReminder).
 */
export function HUD() {
  useTabVisibility();
  useMediaOnTabTitle();
  return null;
}
